import { ToggleButton, ToggleButtonGroup, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface ToggleOption {
  value: string;
  label: string;
}

interface PurpleToggleProps {
  value: string;
  onChange: (value: string) => void;
  options: ToggleOption[];
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const sizeStyles = {
  small: {
    px: 2,
    py: 0.5,
    fontSize: 14,
    fontWeight: 600,
  },
  medium: {
    px: 3,
    py: 1,
    fontSize: 16,
    fontWeight: 700,
  },
};

export const PurpleToggle: FC<PurpleToggleProps> = ({
  value,
  onChange,
  options,
  size = 'small',
  sx,
}) => {
  const sizeStyle = sizeStyles[size];

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => newValue && onChange(newValue)}
      size="small"
      sx={[
        (theme) => ({
          '& .MuiToggleButton-root': {
            ...sizeStyle,
            textTransform: 'none',
            border: `1px solid ${theme.palette.accent.purple}`,
            color: theme.palette.accent.purple,
            '&:hover': {
              backgroundColor: theme.palette.accent.purpleAlpha,
              borderColor: theme.palette.accent.purple,
            },
            '&.Mui-selected': {
              backgroundColor: theme.palette.accent.purple,
              color: 'white',
              '&:hover': {
                backgroundColor: theme.palette.accent.purpleHover,
              },
            },
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
